import React, {useEffect} from 'react';
import DateTimePicker from 'react-datetime-picker';
import FormField from 'mrf/view/FormField';
import dateTimeFormat from 'mrf/utils/DateTimeFormatter';
import { CalendarIcon } from 'mrf/styles/basic/icons';
import StyledDateTimePicker from 'mrf/styles/components/DateTimePicker.styles';
import useLocale from 'mrf/utils/useLocale';
import {useFormContext, useSetFormValueByContext} from "../redux/ReduxHelper";

const valueMapper = e => e;

const DateTimePickerIdWrapper = ({ id, readOnly, value, changed, ...props }) => {
    const context = useFormContext(props.context)
    const set = useSetFormValueByContext(context);
    const field = props.field;

    useEffect(() => {
        if (typeof value === 'string' && value !== '') {
            set({ [field]: new Date(value) })
        }
    },[value]); // eslint-disable-line

    return readOnly
        ? <p>&nbsp;{dateTimeFormat(value)}</p>
        : <StyledDateTimePicker changed={changed} id={id}><DateTimePicker value={value} {...props}/></StyledDateTimePicker>
}

export default function DateTimeField({ openOnFocus, ...props }) {
    return (
        <>
            <FormField
                component={DateTimePickerIdWrapper}
                locale={useLocale()}
                calendarIcon={<CalendarIcon className='icon' />}
                clearIcon={null}
                disableClock
                eventMapper={valueMapper}
                openWidgetsOnFocus={openOnFocus}
                {...props}
            />
        </>
    );
}
